import React from 'react';
import { useGeneralHooks } from '../../../../../Hooks/hooks';
import Button from '../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import useMenuQrHooks from './menuQr-hooks';
import CustomDialog from '../../../../../Components/Dialog/customDialog';
import QrDialog from '../Dialogs/QRMenu/qrDialog';
import { Facebook, Telegram, WhatsApp } from '../../../../../Assets/Icons';
import styles from './qr.module.scss';

export interface IQrProps {
  qrImage: string,
  company_id: number,
  companyTitle: string
}

const Qr: React.FC<IQrProps> = (props) => {
  const {
    isLoading,
    isDialogOpen,
    fullImageUrl,
    selectedSize,
    PRESET_SIZES,
    onOpenDialog,
    onCloseDialog,
    handleDownload,
    shareOnFacebook,
    onSetImageSizes,
    shareOnWhatsApp,
    copyAndShareTelegram,
  } = useMenuQrHooks(props);
  const { t } = useGeneralHooks();


  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <p>
            {
              t('My_Business.Qr.Header')
            }
          </p>
        </div>
        <div className={styles.body}>
          <div className={styles.imageBox}>
            <img src={fullImageUrl} alt='qr.png' />
          </div>
          <Button
            title={t('My_Business.Qr.Dwld_Button_Big')}
            buttonType={ButtonTypes.Primery}
            onClick={onOpenDialog}
            buttonTitleStyle={styles.buttonTitle}
          />
          <div className={styles.shareBox}>
            <div className={styles.buttonsDivider}>
              <div className={styles.dividerLine} />
              <p className={styles.dividerText}>
                {t('Business.Or_Share')}
              </p>
              <div className={styles.dividerLine} />
            </div>
            <div className={styles.socialBox}>

              <img src={Telegram} onClick={copyAndShareTelegram} alt='telegram.svg' className={styles.socialIcon} />
              <img src={WhatsApp} onClick={shareOnWhatsApp} alt='whatsup.svg' className={styles.socialIcon} />
              <img src={Facebook} onClick={shareOnFacebook} alt='faceBook.svg' className={styles.socialIcon} />
            </div>
          </div>
        </div>
      </div>
      <CustomDialog
        open={isDialogOpen}
        onClose={onCloseDialog}
        children={
          <QrDialog
            image={fullImageUrl}
            onDownLoad={handleDownload}
            onClose={onCloseDialog}
            presetData={PRESET_SIZES}
            selectedSize={selectedSize}
            onSetImgSize={onSetImageSizes}
            loading={isLoading}
          />}
      />
    </>
  )
}

export default Qr
